<template>
  <div class="main-mp">
    <client-music @updataState="updataState" @initPlayer="initPlayer" @updataCurrId="updataCurrId"></client-music>
    <share :shareInfo="share.shareInfo" :show="share.showShare" :icon="false"/>
    <div class="header">
      <img src="~@/assets/img/mp/banner.jpg" alt="">
    </div>
    <div class="container">
      <div class="img-block block1">
        <img src="~@/assets/img/mp/H5_1.png" alt="">
      </div>
      <div class="img-block" :class="'block' + (index+2)" v-for="(item,index) in songList" :key="index">
        <img :src="`${require('@/assets/img/mp/'+item.imgUrl)}`" alt="">
        <!-- 歌手头像热区 -->
        <div 
          class="singerImg"
          @click="goSinger(item)"
          :class="{
            left: (index+2)%2 != 0,
            right: (index+2)%2 == 0,
          }">
        </div>
        <!-- 关注 -->
        <div 
          class="attention-icon"
          @click="goSinger(item)"
          :class="{
            left: (index+2)%2 == 0,
            right: (index+2)%2 != 0,
          }">
          <img src="~@/assets/img/pc/attention.png" alt="">
        </div>
        <!-- 专辑热区 -->
        <div 
          class="albumImg"
          @click="goAlbum"
          :class="{
            left: (index+2)%2 != 0,
            right: (index+2)%2 == 0,
          }">
        </div>
        <!-- 播放按钮 -->
        <div 
          class="play-icon play" 
          :class="{
            pause:state == 'playing' && +currId == item.id.qqyin,
            left: (index+2)%2 == 0,
            right: (index+2)%2 != 0,
          }" 
          @click="play(item.id)">
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="img-block block12"><img src="~@/assets/img/mp/H5_12.png" alt=""></div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import os, { plantForm } from "@/utils"
import songList from "@/data/mp"
import share from '@/components/share/index.vue'
require('_a/styles/mp_base.less')
export default {
  name: 'home',
  components: {
    share,
    clientMusic: () => import('@/components/music/client/index.vue')
  },
  data() {
    return {
      os,
      songList,
      player: "",
      state: "",
      currId: "",
      share: {
        showShare: false,
        shareInfo: {
          title: '原力计划2019合辑Ⅰ《地心游记》爆裂来袭',
          link: window.location.href,
          desc: '10位优质唱作人，10首扎心之作，探秘心底两万里，拒绝不痛不痒',
          imgUrl: window.location.protocol+'//'+ window.location.host +require('@/assets/img/mp/share.jpg')
        }
      },
      singerState:{} // 歌手关注状态
    }
  },
  methods: {
    play(songID) {
      // console.log(songID[plantForm])
      // console.log(this.player)
      // this.player.play(songID[plantForm]+'')
      this.player.play(songID[plantForm]);
    },
    // 专辑跳转
    goAlbum() {
      let albumId = {
        qqyin: '6524308',
        kugou: '17996704'
      }
      let id = albumId[plantForm]
      if(os.isQQMusic){
        M.client.invoke("ui", "album", { id })
        return
      }
      window.location.href = 'https://y.qq.com/n/yqq/album/003GFD1D232z4m.html'
    },
    // 歌手跳转
    goSinger(item) {
      let url = item.singerUrl[plantForm]
      let id = item.singerId[plantForm]

      if(os.isQQMusic){
        M.client.invoke("ui", "singer", { id })
        return
      }

      
      if (!url) {
        return;
      }
      window.location.href = url;
    },
    initPlayer(player) {
      this.player = player
      this.player.on("play", el => {
        this.state = el.state;
        this.currId = el.song.id;
      });
      this.player.on("pause", el => {
        this.state = el.state;
        // console.log(this.state)
      });
    },
    updataCurrId(currId) {
      this.currId = currId
    },
    // 更新歌曲状态
    updataState(state) {
      console.log(state)
      this.state = state
    },
    // 更新歌手状态[要从后台取值]
    updateSingerState() {
      if(os.isQQMusic){
        songList.forEach((el) => {
          console.log(el.singerId.qqyin)
        })
      }
    }
  },
  mounted() {
    // this.updateSingerState()
  }
};
</script>

<style lang="less" scoped>
  .main-mp{
    .header{
      img{
        width: 100%;
      }
    }
    .img-block{
      position: relative;
    }
    .play-icon {
      position: absolute;
      width: 80px;
      height: 80px;
      background-position: center center;
      background-size: 100% 100%;
      z-index: 5;
      cursor: pointer;

      &.left {
        left: 288px;
        bottom: 102px;
      }
      &.right {
        right: 85px;
        bottom: 157px;
      }
      &.play {
        background-image: url("~@/assets/img/pc/play.png");
      }
      &.pause {
        background-image: url("~@/assets/img/pc/pause.png");
      }
    }
    .singerImg{
      width: 85%;
      height: 260px;
      position: absolute;
      z-index: 2;
      cursor: pointer;
      &.left {
        top: 166px;
        left: 50px;
      }
      &.right {
        top: 166px;
        right: 63px;
      }
    }
    .albumImg{
      width: 85%;
      height: 330px;
      position: absolute;
      z-index: 2;
      cursor: pointer;
      &.right {
        top: 580px;
        right: 63px;
      }
      &.left {
        top: 580px;
        left: 63px;
      }
      
    }
    .attention-icon {
      position: absolute;
      z-index: 5;
      >img{
        width: 150px;
        height: 54px;
      }
      cursor: pointer;
      &.left {
        left:57px;
        top: 60px;
      }
      &.right {
        top: 60px;
        right: 53px;
      }
    }
    .container{
      .img-block{
        >img{
          width: 100%;
        }
        &.block4{
          .play-icon{
            bottom: 202px;
          }
          .albumImg{
            top: 630px;
          }
        }
        &.block5{
          .play-icon{
            bottom: 208px;
          }
          .albumImg{
            top: 610px;
          }
        }
        &.block6{
          .play-icon{
            bottom: 248px;
          }
          .albumImg{
            top: 590px;
          }
        }
        &.block7{
          .play-icon{
            bottom: 212px;
          }
          .albumImg{
            top: 620px;
          }
        }
        &.block8{
          .play-icon{
            bottom: 222px;
          }
          .albumImg{
            top: 590px;
          }
        }
        &.block9{
          .play-icon{
            bottom: 258px;
          }
          .albumImg{
            top: 630px;
          }
        }
        &.block10{
          .play-icon{
            bottom: 208px;
          }
        }
        &.block11{
          .play-icon{
            bottom: 195px;
          }
        }
      }
    }
    .footer{
      img{
        width: 100%;
      }
    }
  }
</style>
